import { memo } from 'react';
import Link from 'next/link';
import { Stack, Box } from '@chakra-ui/layout';
import { Image } from '@chakra-ui/image';
import { CopyIcon, DeleteIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/tooltip';
import { IconButton } from '@chakra-ui/button';

import { copyTextToClipboard } from '@/shared/utils';

type FileUploaderListItemProps = {
  no: number;
  name: string;
  url: string;
  onDeleteFile: (deletedUrl: string) => void;
};

const FileUploaderListItem = memo(
  ({ no, name, url, onDeleteFile }: FileUploaderListItemProps) => {
    const onClickCopy = (value: string) => {
      try {
        copyTextToClipboard(value);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Could not copy: ', err);
      }
    };

    return (
      <Stack
        direction="row"
        alignItems="center"
        background="white"
        boxShadow="0px 4px 12px -8px rgba(0, 0, 0, 0.2)"
        borderRadius="lg"
        px="1rem"
        py="0.5rem"
      >
        <Box flex="1">{no}</Box>
        <Box flex="5" noOfLines={2}>
          {name}
        </Box>
        <Box flex="3">
          <a target="_blank" href={url} rel="noreferrer">
            <Image
              alt="Pratinjau"
              src={url}
              loading="lazy"
              objectFit="contain"
              maxHeight="4rem"
            />
          </a>
        </Box>
        <Box flex="9" noOfLines={2} display={{ base: 'none', md: 'block' }}>
          <Link prefetch={false} passHref href={url}>
            <a target="_blank">{url}</a>
          </Link>
        </Box>
        <Stack direction="row" flex="2">
          <Tooltip hasArrow label="Copy Link" closeOnClick={false}>
            <IconButton
              aria-label="Copy Link"
              icon={<CopyIcon />}
              colorScheme="teal"
              borderRadius="full"
              fontSize="sm"
              onClick={() => onClickCopy(url)}
            />
          </Tooltip>
          <IconButton
            aria-label="Delete Item"
            icon={<DeleteIcon />}
            colorScheme="red"
            borderRadius="full"
            fontSize="sm"
            onClick={() => onDeleteFile(url)}
          />
        </Stack>
      </Stack>
    );
  },
);

export { FileUploaderListItem };
